// WIZBII
//// Commons
export { Options } from './src/options.interface';

//// Algolia
export { AlgoliaWebservice } from './src/algolia/algolia.webservice';

//// Auth API
export {
  AUTHENTICATION_API_CONFIG,
  AuthenticationApiConfig,
  AuthenticationApiError,
  AuthenticationWebservice,
} from './src/authentication-api/authentication.webservice';

//// Contact API
export { CONTACT_API_CONFIG, ContactApiConfig, ContactWebservice } from './src/contact-api/contact.webservice';

//// File API
export * from './src/file-api/file.webservice';

//// Place API
export * from './src/place-api/city.webservice';

//// Profile API
export { PROFILE_API_CONFIG, ProfileApiConfig, ProfileWebservice } from './src/profile-api/profile.webservice';

//// Company API
export {
  CompanyApiConfig,
  COMPANY_API_CONFIG,
  CompanyWebservice as WizCompanyWebservice,
} from './src/company-api/company.webservice';

//// Job API
export { JOB_API_CONFIG, JobApiConfig } from './src/job-api/job-api.config';
export { ContractWebservice } from './src/job-api/contract.webservice';
export { JobWebservice } from './src/job-api/job.webservice';

//// School API
export { SCHOOL_API_CONFIG, SchoolApiConfig } from './src/school-api/school-api.config';
export { DegreeWebservice } from './src/school-api/degree.webservice';

//// Content API
export { CONTENT_API_CONFIG, ContentApiConfig } from './src/content-api/content-api.config';
export { ContentLegalWebservice } from './src/content-api/content-legal.webservice';
export { ContentWebservice } from './src/content-api/content.webservice';
export { ParamsContentApi, ContentAdvicesApiWebservice } from './src/content-api/content-advices-api.webservice';

//// Account API
export { ACCOUNT_API_CONFIG, AccountApiConfig } from './src/account-api/account.webservice';
export { AccountWebservice } from './src/account-api/account.webservice';

//// Abtest API
export { ABTEST_API_CONFIG, AbTestWebservice } from './src/abtest/abtest.webservice';

//// Consent API
export { ConsentWebservice } from './src/consent-api/consent.webservice';
export { CONSENT_API_CONFIG, ConsentApiConfig } from './src/consent-api/consent-api.config';

//// Suggestions API
export { SUGGESTIONS_API_CONFIG, SuggestionsApiConfig } from './src/suggestions-api/suggestions-api.config';
export {
  UserType,
  SuggestionsWebservice,
  QuestionWithResponse,
  SuggestionResponse,
  CollectivityEnum,
} from './src/suggestions-api/suggestions.webservice';

//// Subscription API
export { SUBSCRIPTION_API_CONFIG, SubscriptionApiConfig } from './src/subscription-api/subscription-api.config';
export { SubscriptionWebservice } from './src/subscription-api/subscription.webservice';

//// Email API
export { EMAIL_API_CONFIG, EmailApiConfig } from './src/email-api/email-api.config';
export { EmailWebservice } from './src/email-api/email.webservice';

//// Fibii API
export { FIBII_API_CONFIG, FibiiApiConfig } from './src/fibii-api/fibii-api.config';
export { FibiiWebservice } from './src/fibii-api/fibii.webservice';
export { FibiiOrdersWebservice } from './src/fibii-api/fibii-orders.webservice';

//// Ops Event API
export { OPS_EVENT_API_CONFIG, OpsEventApiApiConfig } from './src/ops-event-api/ops-event-api.config';
export { EventWebservice } from './src/ops-event-api/event.webservice';

//// Banking Processor API
export {
  BANKING_PROCESSOR_API_CONFIG,
  BankingProcessorApiConfig,
} from './src/banking-processor-api/banking-processor-api.config';
export { BankingUserWebservice } from './src/banking-processor-api/banking-user.webservice';
export { BankingPartnerWebservice } from './src/banking-processor-api/banking-partner.webservice';
export { BankingPersonalInformationWebservice } from './src/banking-processor-api/banking-personal-information.webservice';
export { BankingTrackWebservice } from './src/banking-processor-api/banking-track.webservice';
export { BankingFlowConfigurationWebservice } from './src/banking-processor-api/banking-flow-configuration-webservice.service';

//// Chatbot API
export { CHATBOT_API_CONFIG, ChatbotApiConfig } from './src/chatbot-api/chatbot-api.config';
export { ChatbotWebservice } from './src/chatbot-api/chatbot.webservice';

//// Utils
export { COOKIE_NAME, EXPIRY_COOKIE_NAME, deleteWizbiiCookieTokens, writeWizbiiTokensInCookie } from './src/utils';

export { StrapiWebservice as StrapiService } from '../webservices/src/strapi/strapi.webservice';
